import { ESdChangeReason } from "@kuika/kuika-cl-model";
import { PureComponent } from "react";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { InputTooltip } from "../../../common/input-tooltip";

export interface IConfigTooltipState {}
export interface IConfigTooltipProps {
  contentKey?: string;
}

class ConfigTooltip extends PureComponent<IConfigTooltipProps & IWithSDProps, IConfigTooltipState> {
  constructor(props: IConfigTooltipProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  render() {
    const { contentKey } = this.props;
    const { configLocalizations } = this.props.sd;

    const content = configLocalizations.find((localization) => localization.key === contentKey);
    if (!content) return <></>;

    return (
      <>
        <InputTooltip description={content.description} helpLink={content.helpLink} />
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const configTooltip = withSD<IConfigTooltipProps>(ConfigTooltip);
export { configTooltip as ConfigTooltip };
